var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 2,
    viewBox: "0 0 37 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H36",
    stroke: "black",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDots);
export default __webpack_public_path__ + "static/media/line-dots.8b5f6d44d861b7bbe39bfcbdb481c33e.svg";
export { ForwardRef as ReactComponent };